import React, { useState } from "react";
import styles from "./signup.module.css";
import { Row } from "react-bootstrap";
import { Formik } from "formik";
import SignInInput from "../../common/SigninInput/signinInput";
import PasswordHide from "./assets/PasswordHide.svg";
import PasswordShow from "./assets/PasswordShow.svg";
import passwordicon from "./assets/Password.svg";
import usericon from "./assets/User.svg";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../myContext";
import CommonButton from "../CommonButton/CommonButton";

const LoginInput = ({
  username,
  handleChange,
  setPassword,
  password,
  userExist,
  emailError,
  userNameInvalid,
  userLogin,
  loading,
  passwordInvalid,
  incorrectpasswordoremail,
  showError,
  checkUsernameViaOtp,
  setIncorrectPasswordorEmail,
  setPasswordInvalid,
  ForgotPasswordOtp,
  setStepToShow,
  setUserExist
}) => {
  const [passwordType, setPasswordType] = useState("password");
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    const type = passwordType === "password" ? "text" : "password";
    setPasswordType(type);
  };
  const {themeColor, setIsForgotRoute, setUsername} = useMyContext("");

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (userExist) {
        if (password === "") {
          setIncorrectPasswordorEmail(
            "Password must have 8 or more characters"
          );
          setPasswordInvalid(true);
        } else {
          userLogin();
        }
      } else {
        checkUsernameViaOtp();
      }
    }
  };

  return (
    <>
      {userExist ? (
        <>
          <Row className={styles.title}>Welcome Back!</Row>
          <div className={styles.subsmalltitle}>
            Enter your password to Login.
          </div>
        </>
      ) : (
        <>
          <Row className={styles.title}>Let's get started!</Row>
          <div className={styles.subsmalltitle}>
            Enter your unique email id.
          </div>
        </>
      )}

      <Formik>
        <Row className="ml-0 mr-0 mt-4">
          <SignInInput
            name="email"
            label="Email ID"
            placeholder="Enter Email ID"
            type="text"
            value={username}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            disabled={userExist}
            errorMessage={emailError}
            isInvalid={userNameInvalid}
            icon={usericon}
            onKeyPress={handleKeyPress}
          />
        </Row>
      </Formik>
      {userExist ? (
        <Row className="ml-0 mr-0 mt-2" style={{ position: "relative" }}>
          <SignInInput
            label="Password"
            placeholder="Enter Password"
            name="password"
            type={passwordType}
            value={password}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setPassword(password);
              handleChange(event);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            errorMessage={incorrectpasswordoremail}
            isInvalid={passwordInvalid}
            icon={passwordicon}
            onKeyPress={handleKeyPress}
          />
          {
            <img
              style={{ height: "43px", width: "43px" }}
              alt=""
              className={styles.toggle}
              src={passwordType === "password" ? PasswordHide : PasswordShow}
              onClick={togglePasswordVisibility}
            />
          }
        </Row>
      ) : (
        ""
      )}
      {userExist ? (
        <Row className={styles.forgotRowDiv}>
          <div style={{ marginTop: "8px", paddingLeft: "0px", display: "flex", justifyContent: "space-between"}}>
            <span
              onClick={() => {
                ForgotPasswordOtp();
                navigate("/forgot-password");
                setIsForgotRoute(true);
              }}
              className={styles.forgotText}
            >
              Forgot Password?
            </span>
            <span
              onClick={() => {
                setUserExist(false);
                setUsername("");
                setPassword("");
              }}
              className={styles.forgotText}
            >
              Create New Account?
            </span>
          </div>
        </Row>
      ) : (
        ""
      )}

      <Row className={`${styles.buttonPad} mt-2`}>
        {showError !== "" ? (
          <div className={styles.errorState}>{showError}</div>
        ) : (
          ""
        )}
        <CommonButton
          title={userExist ? "Login" : "Get Started"}
          onClick={
            userExist
              ? () => {
                  if (password === "") {
                    setIncorrectPasswordorEmail(
                      "Password must have 8 or more characters"
                    );
                    setPasswordInvalid(true);
                  } else {
                    userLogin();
                  }
                }
              : () => checkUsernameViaOtp()
          }
          loading={loading}
          disabled={loading}
          padding={"10px 20px"}
        />
      </Row>
    </>
  );
};

export default LoginInput;
